var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSwimmer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 89,
    height: 47,
    viewBox: "0 0 89 47",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "gxm9bn7zca",
    d: "M0 0h29.028v20.638H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "n354w7tchc",
    d: "M0 0h36.09v26.233H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.934.003c.583.006-.505 1.904-.998 2.8l-.102.187c-.416.771-4.393 2.312-5.275 3.906-4.141 7.53-10.916 14.57-24.683 19.361-.854 2.343-4.048 1.5-6.82 2.2l.392.13.096.031c1.029.351 1.137.687 6.654 7.9 5.994 4.125 3.602 7.864 2.774 7.202-.442.55-.545.48-.887.264-1.117 1.377-.943-.175-1.759-2.29-1.596-1.947-1.112-1.899-1.782-.376 0 0 .474.548.541.812.074.277 1.04.798.751 1.063-.435.415.194.424-1.7-.616-1.41-2.147-1.356-1.045.06-4.97-.771-1.396-1.663-1.826-6.311-5.688-4.479-1.485-4.547-.875-4.73.147l-.026.142c-.082.432-.219.92-.719 1.35-.96.812-4.837.147-5.369.308-.535-.1-.531.944-6.244-.035-1.066.423-.85.1-.56-.105 1.562-1.162 10.211-3.576 16.772-5.813 5.959-1.982 9.065-2.56 8.819-8.787-.068-1.195-2.88-3.93-4.274-5.368 3.691-.415 8.699-.28 9.128-.268h.029c-.051-.435-.245-3.056.204-3.09.344 1.131 2.961 1.72 4.467.34.123-.113-.729 3.783-2.07 5.57 4.763-1.573 5.577-2.904 6.241-4.28l.165-.344c.462-.961 1.004-1.954 2.898-3.076 4.388-2.613 5.964-2.388 6.783-5.545.194-1.13 1.472-1.333 2.776-1.502l.435-.056c.936-.124 1.825-.282 2.267-.81",
    id: "ftzdqqsd1e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.574 0c-.539 1.875-.228 2.409.489 4.254-.661-.935-13.091 3.201-14.637 5.61-.461 1.275-.211.763-1.137 2.26-1.85.568-1.426.097-.899-.448l.16-.164c.227-.239.434-.473.443-.625.056-.951.266-1.061-1.433-.52-1.241 1.329-1.924 3.316-2.004 1.99-.165.013-1.861-1.279 1.631-4.61l3.325-.932c5.052-3.285 6.305-3.863 7.472-4.205l.184-.053",
    id: "9cmuflqrth"
  }), /*#__PURE__*/React.createElement("path", {
    id: "6ul7fd53tk",
    d: "M0 0h24.78v17.3H0z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-36.275%",
    y1: "168.356%",
    x2: "232.857%",
    y2: "-221.904%",
    id: "9xdulw9elf"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#173889",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C3CDEB",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-55.82%",
    y1: "178.957%",
    x2: "517.962%",
    y2: "-501.801%",
    id: "bsow4zcehi"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#173889",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C3CDEB",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(46.31)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "f7zifgyi4b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#gxm9bn7zca"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M19.347 14.804c-.961 4.239-3.548 4.61-9.094 5.462-1.683.128-5.639 1.697-10.253-2.74.559-1.217 4.199-2.067 6.163-2.281 11.918-1.343 8.573 1.824 9.156-3.343.432-3.79 4.048-5.795 5.012-7.998 1.156-2.642-.936-3.273 3.144-3.49 1.321-.068 3.545-.732 4.32-.224 4.412 2.83-4.107-4.35-8.448 14.614",
    fill: "#F19E8C",
    mask: "url(#f7zifgyi4b)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M34.367 27.177C15.971 41.888 23.761 32.508 6.118 41.12c-.514.801-.903 1.842-1.829 3.34-2.837.87-.327-.702-.296-1.239.056-.95.266-1.06-1.433-.519C1.319 44.03.636 46.016.556 44.691c-.165.013-1.861-1.28 1.631-4.61l3.325-.933c9.664-6.282 8.038-3.774 10.609-5.133 12.819-7.086 14.923-7.407 18.246-6.838",
    fill: "#F19E8C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.795 27.743c-.855 2.348-4.034 1.497-6.82 2.199-.795.145-5.498 2.017-5.73 2.712-.756 4.806-3.903 1.978-6.285 2.698-.5-.094-1.497 1.113-7.306-.237-12.677-2.584 3.676-7.841 3.693-7.941 4.607-1.528 4.944-1.993 4.844-1.92 4.285-3.13 6.846-13.374 12.082-7.102 1.644.06 4.572.71 5.29 2.114.768 1.084 1.11 4.984.232 7.477",
    fill: "#F19E8C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.742 27.753c-.618 2.282-4.125 1.523-6.767 2.19-10.73 1.947-1.202 6.1-11.473 5.38 6.482-3.585 6.143-6.85 4.091-7.305-3.241-.748-9.168 2.002-7.092 5.401 1.474 2.431 3.736 1.536 1.476 2.222-8.493-4.626 2.93-9.361 3.144-9.537.539-.445 2.282-1.431-.93-.85 4.285-3.13 6.846-13.375 12.082-7.103 1.516-.224 3.646.05 4.65 1.405 1.144 1.546 1.431 6.108.819 8.197",
    fill: "#EA1F16"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(51.93 1.486)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "8m62knwj6d",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#n354w7tchc"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M34.822 2.99c-.416.772-4.393 2.313-5.275 3.907-7.708 14.015-25.49 21.078-28.095 18.97-2.887-2.402-1.293-8.32 3.214-8.226 5.186.138 11.824-2.68 12.805-3.976 1.167-1.616 1.772-3.657 4.133-5.055 4.388-2.612 5.964-2.388 6.783-5.544.355-2.073 4.356-1.028 5.48-2.37.595-.7 1.43-.708 2.055-.692.628.006-.682 2.206-1.1 2.987",
    fill: "#F3A391",
    mask: "url(#8m62knwj6d)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M34.355 34.358c-1.963.818-5.744 2.497-6.74.723-1.464-2.614.092-1.295 1.844-3.59 4.363.017 5.373 2.682 4.896 2.867",
    fill: "#F5A997"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.68 37.306s-2.039-1.538-1.999-4.008c.07-4.41 9.065-4.367 7.177.858-4.715 2.508-3.512 1.737-5.179 3.15",
    fill: "#0A3192"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.048 31.116c-1.666-3.725 8.709 3.73 4.682 6.341-2.123 1.377-9.092 1.262-8.673-1.388.173-1.096.995-3.438 1.461-3.734.56-.356 6.322.532 2.53-1.219",
    fill: "#F8B4A1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.24 31.821c-.195.79-5.351.43-4.023 6.312-1.74.905-4.89-2.205-3.566-6.009.628-3.669 8.097-2.348 7.59-.303",
    fill: "#EA1F16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.144 34.05c1.733-3.514-2.827-4.613-.487-4.212 5.309 5.524 1.185 6.525 1.312 6.923.126.4.814.898.622 1.574-.193.676-1.88.418-2.01.107-.416-.999.653-1.895.517-2.896-.026-.193-.18-1.038.046-1.496",
    fill: "#CAD4E4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.747 34.481c-.523 1.56.807 1.742 1.104 1.04.66-1.563-.681-2.366-1.104-1.04M25.006 37.75c-.523 1.558.807 1.741 1.104 1.038.66-1.563-.682-2.36-1.104-1.039",
    fill: "#0A3192"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(30.919 1.486)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "uc0xmdp76g",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ftzdqqsd1e"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M55.834 2.99c-.416.771-4.393 2.312-5.275 3.906-4.141 7.53-10.916 14.57-24.683 19.361-.854 2.343-4.048 1.5-6.82 2.2 1.588.548.873-.136 7.142 8.061 5.994 4.125 3.602 7.864 2.774 7.202-.442.55-.545.48-.887.264-1.117 1.377-.943-.175-1.759-2.29-1.596-1.947-1.112-1.899-1.782-.376 0 0 .474.548.541.812.074.277 1.04.798.751 1.063-.435.415.194.424-1.7-.616-1.41-2.147-1.356-1.045.06-4.97-.771-1.396-1.663-1.826-6.311-5.688-6.515-2.16-3.697.111-5.475 1.64-.96.811-4.837.146-5.369.307-.535-.1-.531.944-6.244-.035-1.066.423-.85.1-.56-.105 1.562-1.162 10.211-3.576 16.772-5.813 5.959-1.982 9.065-2.56 8.819-8.787-.068-1.195-2.88-3.93-4.274-5.368 3.859-.434 9.157-.268 9.157-.268-.051-.435-.245-3.056.204-3.09.344 1.131 2.961 1.72 4.467.34.123-.113-.729 3.783-2.07 5.57 8.468-2.797 4.455-4.83 9.304-7.7 4.388-2.613 5.964-2.388 6.783-5.545.355-2.073 4.356-1.028 5.478-2.369.597-.699 1.43-.709 2.057-.693.628.006-.682 2.207-1.1 2.987",
    fill: "url(#9xdulw9elf)",
    mask: "url(#uc0xmdp76g)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(.012 32.336)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "imm5dhc33j",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#9cmuflqrth"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M20.063 4.254c-.661-.935-13.091 3.201-14.637 5.61-.461 1.275-.211.763-1.137 2.26-2.837.871-.327-.7-.296-1.237.056-.951.266-1.061-1.433-.52-1.241 1.329-1.924 3.316-2.004 1.99-.165.013-1.861-1.279 1.631-4.61l3.325-.932C15.484.332 10.654 4.392 19.574 0c-.539 1.875-.228 2.409.489 4.254",
    fill: "url(#bsow4zcehi)",
    mask: "url(#imm5dhc33j)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(36.178 28.726)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "ly0zmy79rl",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#6ul7fd53tk"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m22.826 16.744-.412.508c-.157.177-.72-.088-.91-1.668-.55-1.422-.183-.82-1.704-2.676l-.515 1.17s.475.548.541.813c.074.276 1.04.797.751 1.062-.435.416.194.424-1.7-.616l-1.119-1.703c1.142-3.167 1.835-3.37-.52-5.193-3.822-2.937-4.635-4.762-9.178-4.473C6.807 3.933 5.323 5.22 3.97 5.63.892 6.509-2.178 1.505 2.123.008 2.326-.06 9.687.32 11.75.674c3.855.712 3.225.806 9.19 8.604 5.975 4.113 3.631 8.57 1.886 7.466",
    fill: "#F8B4A1",
    mask: "url(#ly0zmy79rl)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwimmer);
export default __webpack_public_path__ + "static/media/swimmer.4903ce19bb336dd5e0f2f7713ed6c607.svg";
export { ForwardRef as ReactComponent };